<template>
  <div class="box1">
    <div class="title">短视频掘金流量陪跑训练营</div>
    <div class="block">
      <p>“精细化”实战陪跑，针对不同程度学员制定专属学习计划</p>
      <p>7至10年专业运营师全程陪跑</p>
      <p>百万粉丝大V参与课研</p>
      <p>每周实时更新抖音新玩法</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  height: 600px;
  background: url("../../../assets/coursePage/media/box1/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .title {
    height: 54px;
    font-size: 56px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #0d004d;
    line-height: 54px;
    text-shadow: 0px 20px 60px rgba(126, 107, 221, 0.2);
    margin: 105px 0 54px 42px;
  }
  .block {
    font-size: 24px;

    font-weight: 400;
    color: #242a33;
    margin-left: 57px;

    p {
      margin-bottom: 24px;
      &::after {
        content: "";
        width: 89px;
        height: 5px;
        display: block;
        background: url("../../../assets/coursePage/media/box1/icon.png")
          no-repeat;
        background-size: cover;
        margin: 5px 0 10px -15px;
      }
    }
  }
}
</style>
